import React from 'react'
import '../style/bindPop.scss'
import { util } from '../config'
import axios from 'axios'
import qs from 'qs'
class BindPop extends React.Component {
  constructor(props) {
    super();
    this.state = {
      roleid: '',
      code: '',
      countDown: 0,
      isBindSend: false,
      step: 1
    }
  }
  timer = null;

  handleInputChange = (e) => {
    const target = e.currentTarget;
    const name = target.dataset.name;
    this.setState({ [name]: target.value })
  }

  handleSendGameCode = () => {
    if (!this.state.roleid) {
      util.showToast({ msg: '请输入游戏账号' });
      return;
    }
    if (this.state.countDown !== 0) {
      return;
    }
    axios.post('https://actblood.web.sdo.com/Api/2020/1012/SendG.ashx', qs.stringify({
      roleid: this.state.roleid
    })).then(res => {
      if (res.data.success) {
        this.setState({ countDown: 60 });
        this.timer = setInterval(() => {
          const second = this.state.countDown - 1;
          this.setState({ countDown: second });
          if (second === 0) {
            clearInterval(this.timer);
          }
        }, 1000);
      } else {
        util.showToast({ msg: res.data.msg })
      }
    })
  }

  updateStep = (e) => {
    const step = Number(e.currentTarget.dataset.step);
    this.setState({
      step
    })
  }

  doBind = () => {
    if (this.state.isBindSend) {
      return;
    }
    this.setState({ isBindSend: true })
    axios.post('https://actblood.web.sdo.com/Api/2020/1012/Bind.ashx', qs.stringify({
      roleid: this.state.roleid,
      vcode: this.state.code
    })).then(res => {
      this.setState({ isBindSend: false })
      if (res.data.success) {
        this.setState({ step: 3 })
        this.props.updateLoadInfo();
      } else {
        util.showToast({ msg: res.data.msg })
      }
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.step !== this.state.step && this.state.step === 1) {
      clearInterval(this.timer);
      this.setState({
        roleid: '',
        code: '',
        countDown: 0,
        isBindSend: false
      })
    }
    if (prevProps.isBindPopShow !== this.props.isBindPopShow && this.props.isBindPopShow) {
      this.setState({ step: 1 });
    }
  }

  render() {
    return (
      <div className="popup bind-pop">
        <div className="content">
          <div className="step step1" style={{ 'display': this.state.step === 1 ? 'block' : 'none' }}>
            <div className="title"></div>
            <div className="input-container">
              <input id="roleid" data-name="roleid" type="text" placeholder="请输入游戏ID" value={this.state.roleid} onChange={this.handleInputChange} />
              <input id="game-code" data-name="code" type="text" placeholder="游戏验证码" value={this.state.code} onChange={this.handleInputChange} />
              <div className="get-code" onClick={this.handleSendGameCode}>
                {(this.state.countDown === 0) && <span>获取验证码</span>}
                {!(this.state.countDown === 0) && <span>已发送（{this.state.countDown}s）</span>}
              </div>
              <div className="confirm" data-step="2" onClick={this.updateStep}></div>
            </div>
            <ul>
              <li>※ 游戏ID获取方式：进入游戏首页→菜单→个人信息→ID。</li>
              <li>※ 验证码直接发送至对应ID账号的邮箱中。</li>
              <li>※ 1个预约手机号最多登记5个游戏角色。</li>
              <li>※ 游戏角色一旦绑定，不可换绑、解绑。</li>
            </ul>
          </div>
          <div className="step step2" style={{ 'display': this.state.step === 2 ? 'block' : 'none' }}>
            <div className="title"></div>
            <div className="info">
              <p>手机号：<span className="phone-num">{this.props.phone}</span>&emsp;&emsp;即将绑定账号id：<span className="roleid">{this.state.roleid}</span>
              </p>
              <p>确认绑定后将无法更改或解绑</p>
              <div className="btn-container">
                <div className="cancel" data-step="1" onClick={this.updateStep}></div>
                <div className="confirm" onClick={this.doBind}></div>
              </div>
            </div>
          </div>
          <div className="step step3" style={{ 'display': this.state.step === 3 ? 'block' : 'none' }}>
            <div className="title"></div>
            <div className="info">
              <p>邀请好友人数满足要求即可在页面中<br />领取对应奖励，</p>
              <p>一个手机号最多可登记5个游戏角色领奖</p>
            </div>
            <div className="bind-again" onClick={() => { this.setState({ step: 1 }) }}></div>
          </div>
          <div className="close" onClick={() => { this.setState({ step: 1 }); this.props.closeBindPop(); }}></div>
        </div>
      </div>
    )
  }
}

export default BindPop;
